import React, {FC} from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

type LoadingScreenProps = {
  loadingComponent?: React.ReactNode;
};
const LoadingScreen: FC<LoadingScreenProps> = ({loadingComponent}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      my={loadingComponent ? 0 : 4}>
      {loadingComponent || <CircularProgress size={40} />}
    </Box>
  );
};

export default LoadingScreen;
